import { takeLatest, call, delay, put, select } from "redux-saga/effects"

import {
  USER_LOGIN_SUCCESSFUL,
  USER_REGISTRATION_SUCCESSFUL,
  USER_REGISTRATION_FAILED,
  USER_LOGOUT_REQUESTED,
  USER_LOGOUT_SUCCESS,
  USER_LOGIN_FAILED,
  USER_FORGOT_PASSWORD_FAILED,
  USER_RESET_PASSWORD_FAILED,
  USER_RESEND_EMAIL_FAILED,
  USER_RESEND_EMAIL_SUCCESSFUL,
  USER_CHANGE_PASSWORD_SUCCESSFUL,
  USER_CHANGE_PASSWORD_FAILED,
  SIGN_UP_FACEBOOOK_SUCCESS,
  SIGN_UP_FACEBOOOK_FAILED,
  SIGN_IN_FACEBOOOK_SUCCESS,
  SIGN_IN_FACEBOOOK_FAILED,
  SIGN_UP_GOOGLE_SUCCESS,
  SIGN_UP_GOOGLE_FAILED,
  SIGN_IN_GOOGLE_SUCCESS,
  SIGN_IN_GOOGLE_FAILED,
  GET_TOKEN_PROFILE_SUCCESS,
  GET_TOKEN_PROFILE_FAILED,
  LOGIN_WALLET_ADDRESS_SUCCESSFUL,
} from "./action-types"

import { showResponseModal, closeResponseModal } from "store/user/actions"
import { setAuthError } from "./action"
import {
  ERROR_500,
  getSuccessRegistrationSpiel,
  MODAL_MESSAGES,
} from "constants/message"
import { RESPONSE_MODAL_TYPES } from "constants/modal-types"
import {
  fetchAllCourses,
  fetchAllBundles,
  fetchCourseById,
  fetchBundleById,
} from "store/courses/action"
import history from "app/history"
import { checkParams, amountFormatter } from "helpers/util"
import { toast } from "react-toastify"

const DEFAULT_QUERY_PARAM = {
  pageNumber: `page=1`,
  rowsPerPage: `perpage=6`,
  sortParam: "sort=-created_at",
}
function* watchLoginSuccess() {
  yield takeLatest(
    [
      USER_LOGIN_SUCCESSFUL,
      SIGN_IN_FACEBOOOK_SUCCESS,
      SIGN_IN_GOOGLE_SUCCESS,
      LOGIN_WALLET_ADDRESS_SUCCESSFUL,
    ],
    function* handleLoginSuccess({ payload }) {
      const {
        data: { token, student_id, id: user_id, role },
      } = payload
      const path = window.location.pathname
      const auth = yield select((state) => state.authReducer)
      const school = yield select((state) => state.schoolReducer)
      // let rememberToggle = JSON.parse(requestData);
      // if (rememberToggle.keepLoggedIn === true) {
      yield localStorage.setItem("token", token)
      yield localStorage.setItem("userId", student_id || user_id)
      yield localStorage.setItem("studentId", user_id)
      yield localStorage.setItem("role", role)
      if (["/courses"].includes(path)) {
        yield put(
          fetchAllCourses(
            checkParams(DEFAULT_QUERY_PARAM),
            school?.schoolData?.id,
            auth.isAuthorized
          )
        )
      } else if (["/course-bundles"].includes(path)) {
        yield put(
          fetchAllBundles(
            checkParams(DEFAULT_QUERY_PARAM),
            school?.schoolData?.id,
            auth.isAuthorized
          )
        )
      } else if (path.includes("/course/")) {
        const courses = yield select((state) => state.coursesReducer)
        const {
          selectedCourse: { id: courseId },
        } = courses
        yield put(fetchCourseById(courseId))
      } else if (path.includes("course-bundle")) {
        const courses = yield select((state) => state.coursesReducer)
        const { selectedBundle } = courses
        yield put(fetchBundleById(selectedBundle?.id))
      }
    }
  )
}

function* watchTokenProfileSuccess() {
  yield takeLatest(
    [GET_TOKEN_PROFILE_SUCCESS],
    function* handleTokenProfileSuccess({ payload }) {
      const {
        data: { student_id, id: user_id, role },
      } = payload

      yield localStorage.setItem("userId", student_id || user_id)
      yield localStorage.setItem("studentId", user_id)
      yield localStorage.setItem("role", role)

      const params = new URLSearchParams(window.location.search)

      if (params.has("redirect")) {
        const redirect = params.get("redirect")
        const redirectURL = new URL(`https://${redirect}`)

        history.push(redirectURL.pathname)
      } else {
        history.push("/courses")
      }
    }
  )
}

function* watchTokenProfilefailed() {
  yield takeLatest(
    [GET_TOKEN_PROFILE_FAILED],
    function* handleTokenProfilefailed({ payload }) {
      yield localStorage.removeItem("userId")
      yield localStorage.removeItem("studentId")
      yield localStorage.removeItem("token")
      yield localStorage.removeItem("role")

      toast.error("Invalid token", { autoClose: 3000 })

      history.push("/")
    }
  )
}

function* watchRegisterSuccess() {
  yield takeLatest(
    USER_REGISTRATION_SUCCESSFUL,
    function* handleRegisterSuccess({ payload }) {
      const {
        data: { token, student_id, id: user_id },
      } = payload
      yield localStorage.setItem("token", token)
      yield localStorage.setItem("userId", student_id || user_id)
      yield localStorage.setItem("studentId", user_id)
      yield localStorage.setItem("role", "ST")
      yield delay(2000)
      yield call(() => history.push("/student/profile"))
    }
  )
}

function* watchSSORegisterSuccess() {
  yield takeLatest(
    [SIGN_UP_FACEBOOOK_SUCCESS, SIGN_UP_GOOGLE_SUCCESS],
    function* handleRegisterSuccess({ payload }) {
      const {
        data: { token, student_id, id: user_id, has_reward },
      } = payload
      yield localStorage.setItem("token", token)
      yield localStorage.setItem("userId", student_id || user_id)
      yield localStorage.setItem("studentId", user_id)
      yield localStorage.setItem("role", "ST")
      yield delay(2000)
      yield call(() => history.push("/student/profile"))
      let modalData = {
        modalType: RESPONSE_MODAL_TYPES.SUCCESS,
        header: "User Registration Successful",
        actionLabel: "OK",
        action: () => closeResponseModal(),
      }
      if (has_reward) {
        modalData.message = getSuccessRegistrationSpiel(
          has_reward?.fb_group,
          amountFormatter(has_reward?.amount, 0)
        )
      } else {
        modalData.message = MODAL_MESSAGES.SSO_REGISTRATION_SUCCESS
      }
      yield put(showResponseModal(modalData))
    }
  )
}

function* watchRegisterFailed() {
  yield takeLatest(
    [
      USER_LOGIN_FAILED,
      USER_REGISTRATION_FAILED,
      USER_RESET_PASSWORD_FAILED,
      USER_FORGOT_PASSWORD_FAILED,
      USER_CHANGE_PASSWORD_FAILED,
      SIGN_UP_FACEBOOOK_FAILED,
      SIGN_IN_FACEBOOOK_FAILED,
      SIGN_UP_GOOGLE_FAILED,
      SIGN_IN_GOOGLE_FAILED,
    ],
    function* handleRegisterFailed({ error }) {
      const { status, data } = error.response
      if (status === 500) {
        yield put(setAuthError(ERROR_500))
      } else {
        yield put(setAuthError(data))
      }
    }
  )
}

function* watchResendEmailFailed() {
  yield takeLatest(
    USER_RESEND_EMAIL_FAILED,
    function* handleRegisterFailed({ error }) {
      const { status, data } = error.response
      if (status === 500) {
        yield put(setAuthError(ERROR_500))
      } else {
        // const path = window.location.pathname;

        // if (path.endsWith("profile") || path.endsWith("settings")) {
        let modalData = {
          modalType: RESPONSE_MODAL_TYPES.ERROR,
          header: "Failed to send Email Verification",
          message: data.error,
          actionLabel: "OK",
          action: () => closeResponseModal(),
        }
        yield put(showResponseModal(modalData))
        // }
        yield put(setAuthError(data))
      }
    }
  )
}

function* watchLogoutRequested() {
  yield takeLatest(USER_LOGOUT_REQUESTED, function* handleLogOutSuccess() {
    yield localStorage.removeItem("userId")
    yield localStorage.removeItem("studentId")
    yield localStorage.removeItem("role")
    if (window.FB) {
      yield window.FB.api("/me/permissions", "delete", null, () =>
        window.FB.logout()
      )
    }
  })
}

function* watchLogoutSuccess() {
  yield takeLatest(USER_LOGOUT_SUCCESS, function* handleLogOutSuccess() {
    yield localStorage.removeItem("token")
    yield call(() => history.push("/"))
    toast.success("User logged out.", { autoClose: 3000 })
  })
}

function* watchChangePasswordSuccess() {
  yield takeLatest(
    USER_CHANGE_PASSWORD_SUCCESSFUL,
    function* handleChangePassword() {
      let modalData = {
        modalType: RESPONSE_MODAL_TYPES.SUCCESS,
        header: "Change Password",
        message: "Password successfuly changed!",
        actionLabel: "OK",
        action: () => closeResponseModal(),
      }
      yield put(showResponseModal(modalData))
    }
  )
}

function* watchResendEmailSuccess() {
  yield takeLatest(USER_RESEND_EMAIL_SUCCESSFUL, function* handleResendEmail() {
    let modalData = {
      modalType: RESPONSE_MODAL_TYPES.SUCCESS,
      header: "Email Verification Sent",
      message:
        "Please open your e-mail and check for a message with subject: Apptitude: Email Verification. If it's not in the inbox. please check your spam folder.",
      actionLabel: "OK",
      action: () => closeResponseModal(),
    }
    yield put(showResponseModal(modalData))
  })
}

export default [
  watchLoginSuccess,
  watchRegisterSuccess,
  watchRegisterFailed,
  watchLogoutRequested,
  watchLogoutSuccess,
  watchChangePasswordSuccess,
  watchResendEmailSuccess,
  watchResendEmailFailed,
  watchSSORegisterSuccess,
  watchTokenProfileSuccess,
  watchTokenProfilefailed,
]
